import React, { createContext, useContext, useEffect, useMemo } from "react";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";

const dictionaries = { fr, en };

const I18nContext = createContext({ lang: "fr", t: (k) => k });

function getFromPath(obj, path) {
  return path.split(".").reduce((acc, key) => {
    if (acc && typeof acc === "object" && key in acc) return acc[key];
    return undefined;
  }, obj);
}

export function I18nProvider({ lang, children }) {
  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.fr;
    const t = (key) => {
      const value = getFromPath(dict, key);
      if (value === undefined) return key;
      return value;
    };
    return { lang, t, dict };
  }, [lang]);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
      const title = value.t("meta.title");
      const desc = value.t("meta.description");
      if (title) document.title = title;
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      if (desc) meta.setAttribute("content", desc);
    }
  }, [lang, value]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
